export default __webpack_public_path__ + "static/media/Home.a48d5bd8.svg";